module.exports = __webpack_public_path__ + "static/make-video-slide1@2x-de47b45a05d5e2be85e5bc301e24284b.png";